// This service is responsible uses the legacy public ajax API to create a checkout session
import Axios from "axios";
import {BookingkitCheckoutApiError} from "../Errors/BookingkitCheckoutApiError";
import {NotConnectedError} from "../Errors/NotConnectedError";

type Session = {
    id: string;
}

const isAbortedRequestError = (error: any): boolean => {
    const message = typeof error?.message === "string" ? error.message.toLowerCase() : "";
    return error?.code === "ERR_CANCELED"
        || error?.code === "ECONNABORTED"
        || error?.name === "CanceledError"
        || message.includes("request aborted")
        || message === "canceled";
}

export class CheckoutApi {
    private readonly baseUrl: string;
    constructor({baseUrl}:{baseUrl: string}) {
        this.baseUrl = baseUrl;
    }
    async createSession(): Promise<Session> {
        try {
            const response = await Axios.get(`${this.baseUrl}GetWidgetSessionId`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return {
                id: response.data.checkout_session_id as string
            }
        } catch (e: any) {
            if (!Axios.isAxiosError(e)){
                throw e;
            }
            if (e.code === "ERR_NETWORK" || isAbortedRequestError(e)){
                throw NotConnectedError.fromResponseCodeZero();
            }
            throw BookingkitCheckoutApiError.fromServerError(e);
        }

    }

}
